'use client'

import { useRouter } from 'next/router'
import { useEffect, useRef } from 'react'

import useAppDispatch from '../../../store/hooks/useAppDispatch'
import { showAuthModal } from '../store/authSlice'
import { AuthModalType, AuthSignInIntent } from '../types'
import { authCustomerIsLoggedInSelector } from '../store/authSelectors'
import { clientContextFetchPendingSelector } from '../../clientContext/store/clientContextSelectors'
import useAppSelector from '../../../store/hooks/useAppSelector'
import isAppWhiteLabeled from '../../app/utils/isAppWhiteLabeled'

const AuthModalFilterKeys = {
  SignIn: 'signin',
  ForgotPassword: 'forgotpassword',
}

const AuthModalMapByFilterKey = {
  [AuthModalFilterKeys.SignIn]: AuthModalType.SignIn,
  [AuthModalFilterKeys.ForgotPassword]: AuthModalType.ForgotPassword,
}

export default function AuthSignInURLFilter() {
  const dispatch = useAppDispatch()

  const { query } = useRouter()

  const isTriggeredRef = useRef<boolean>(false)

  const isLoggedIn = useAppSelector(authCustomerIsLoggedInSelector)

  const isClientContextLoading = useAppSelector(
    clientContextFetchPendingSelector,
  )

  useEffect(() => {
    const authFilterURLFlag = Object.keys(query).find(key =>
      Object.values(AuthModalFilterKeys).includes(key.toLowerCase()),
    )

    if (
      !!authFilterURLFlag &&
      isLoggedIn === false &&
      !isTriggeredRef.current &&
      !isClientContextLoading
    ) {
      isTriggeredRef.current = true

      const authModalType =
        AuthModalMapByFilterKey[authFilterURLFlag.toLowerCase()]

      // `?signin&as=company` signs in to a company profile, which only
      // white-label apps have
      const isCompanySignIn =
        isAppWhiteLabeled() &&
        authModalType === AuthModalType.SignIn &&
        String(query.as).toLowerCase() === AuthSignInIntent.Company

      dispatch(
        showAuthModal(
          isCompanySignIn
            ? { type: authModalType, intent: AuthSignInIntent.Company }
            : authModalType,
        ),
      )
    }
  }, [dispatch, isClientContextLoading, isLoggedIn, query])

  return null
}
